import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { bankInformationQueries } from '@/services/payment/payment.queries';

export const useBankInformation = () => {
  const { data, isPending, isSuccess, dataUpdatedAt } = useQuery(bankInformationQueries.detail());

  return {
    bankInformation: data?.data,
    isPending,
    isSuccess,
    dataUpdatedAt,
  };
};
